import {Component} from '@angular/core';

@Component({
  selector: 'as-layout-no-sidebar',
  templateUrl: './layout-no-sidebar.component.html',
  styleUrls: ['./layout-no-sidebar.component.scss'],
})
export class LayoutNoSidebarComponent {
}
